import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './InvestmentDetails.css'
import PageTitle from '../components/UI/PageTitle'
import { getInvestmentById } from '../api/Index'
import { CiEdit } from 'react-icons/ci'
import { useAuth } from '../api/Authcontext'

const InvestmentDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { userData } = useAuth();
    const [investment, setInvestment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInvestmentDetails = async () => {
            setLoading(true);
            setError(null);
            try {
                // Get investment ID from URL query parameters
                const searchParams = new URLSearchParams(location.search);
                const investmentId = searchParams.get('id');
                
                if (!investmentId) {
                    setError('Investment ID not provided');
                    return;
                }

                const response = await getInvestmentById(investmentId);
                console.log('Investment details response:', response);
                
                // Handle backend response structure
                let investmentData = null;
                if (response.data) {
                    investmentData = response.data;
                }
                
                setInvestment(investmentData);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching investment details:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchInvestmentDetails();
    }, [location.search]);

    const handleEditInvestment = () => {
        const searchParams = new URLSearchParams(location.search);
        const investmentId = searchParams.get('id');
        navigate(`/edit-investment?id=${investmentId}`);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Not available';
        return new Date(dateString).toLocaleDateString();
    };

    const formatCurrency = (amount) => {
        if (!amount) return 'Not specified';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'KES'
        }).format(amount);
    };

    if (loading) {
        return (
            <div>
                <PageTitle title="Investment Details" />
                <div>Loading investment details...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <PageTitle title="Investment Details" />
                <div style={{color: 'red'}}>Error: {error}</div>
            </div>
        );
    }

    if (!investment) {
        return (
            <div>
                <PageTitle title="Investment Details" />
                <div>Investment not found.</div>
            </div>
        );
    }

    
  return (
    <div className="">
        <PageTitle title={'Investment Details'} />
        {userData?.role === 'admin' && (
            <button onClick={handleEditInvestment}>
                <CiEdit />Edit Investment
            </button>
        )}
        <div className="investment-details-container">
            <div className="investment-header">
                <h2>{investment.name}</h2>
                <span className={`investment-status-badge ${investment.status?.toLowerCase() || 'active'}`}>
                    Status: {investment.status || 'Active'}
                </span>
            </div>

            <h4 style={{ fontWeight: 'bold', color: 'grey' }}>INVESTMENT DETAILS</h4>
            
            <div className="investment-section">
                <h4>DESCRIPTION</h4>
                <p>{investment.description || 'No description available'}</p>
            </div>

            <div className="investment-section">
                <h4>DATES</h4>
                <p><strong>Start Date:</strong> {formatDate(investment.startDate)}</p>
                <p><strong>End Date:</strong> {formatDate(investment.endDate)}</p>
            </div>

            <div className="investment-section">
                <h4>FINANCIAL DETAILS</h4>
                <p><strong>Amount Invested:</strong> {formatCurrency(investment.amountInvested || investment.amount)}</p>
                <p><strong>Expected Return:</strong> {formatCurrency(investment.expectedReturn)}</p>
            </div>

            {investment.createdBy && (
                <div className="investment-section">
                    <h4>CREATED BY</h4>
                    <p><strong>Creator ID:</strong> {investment.createdBy}</p>
                </div>
            )}
        </div>
    </div>
  )
}

export default InvestmentDetails